export default __webpack_public_path__ + "static/tempronics-hover-b7bb95b25bcd3f647851386219386b0b.png";